import React from "react";

import AccessoriesRoute from "../../features/accessories/AccessoriesRoute";

const Accessories = () => (
  <div className="accessories-page full-bleed">
    <AccessoriesRoute />
  </div>
);

export default Accessories;
